import { PageLoansPaymentView } from './View';
import { PageLoansPaymentCreate } from './Create';
import { PageLoansPaymentOverview } from './Overview';

export const PAYMENTS = {
  LoansPaymentView: PageLoansPaymentView,
  LoansPaymentCreate: PageLoansPaymentCreate,
  LoansPaymentOverview: PageLoansPaymentOverview,
} as const;
